const IMPACT_BASE_URL = process.env.REACT_APP_IMPACT_API_URL || "https://api.impact.com";
const IMPACT_API_ID = process.env.REACT_APP_IMPACT_API_ID || "";
const IMPACT_API_KEY = process.env.REACT_APP_IMPACT_API_KEY || "";

export const getImpactBaseUrl = () => IMPACT_BASE_URL.replace(/\/$/, "");
export const getImpactAuthHeader = () => {
    if (!IMPACT_API_ID || !IMPACT_API_KEY) return "";
    return `Basic ${btoa(`${IMPACT_API_ID}:${IMPACT_API_KEY}`)}`;
};
export const getImpactMediaPartnersPath = () => `${getImpactBaseUrl()}/Mediapartners/${IMPACT_API_ID}`;
